
import GoogleMaps from '../../components/GoogleMaps';
import { Wrapper } from "@googlemaps/react-wrapper";
import headerImage from "../../assets/lingotti/0017 - Still life Care is gold-Modifica.webp";
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import logo from '../../assets/oroPrestige/logo-trasp.webp';
import Static from '../../components/Static';
import AOS from "aos";
import "aos/dist/aos.css";
import Form from '../../components/Form';
import { getContactFormFields } from "../../utils/formFields";
import { schemaContattiCare } from "../../components/formComponent/formSchema";
import { useState, useEffect } from "react";

function Contatti() {
  const [showMap, setShowMap] = useState(false)

  const googleMaps = 'AIzaSyCZyoDZ5eFh61i2vM3zyDXUI3WVp3J4E9Y'

  var ogImage = 'https://www.careisgold.it/static/media/0017%20-%20…re%20is%20gold-Modifica.58621a994aaa6176c39c.webp';

  useEffect(() => {
    if (window.location.hostname !== 'localhost') {
      setShowMap(true);
    }
  }, []);

  
  // togliere aos transition per mini-screen
  function initAOS() {
      AOS.init({
        disable: window.innerWidth <= 320 && window.innerHeight <= 256
      });
  }
    
  initAOS();
  
  window.addEventListener("resize", () => {
  AOS.refreshHard();
  });

  const submitMapper = ({ data, landingName, idOrigin }) => ({
    NomeModulo: landingName,
    Provenienza: idOrigin,
    Dati: [
      { Key: "NomeCognome", Value: data.nomeCognome || "" },
      { Key: "Telefono", Value: data.telefono || "" },
      { Key: "Email", Value: data.email || "" },
      { Key: "InteressatoA", Value: data.InteressatoA || "" },
      { Key: "Messaggio", Value: data.messaggio || "" },
      { Key: "Provincia", Value: data.provincia || "" },
      {
        Key: "ComeCiHaConosciuto",
        Value:
          data.ComeCiHaConosciuto === "Altro..."
            ? data.altro
            : data.ComeCiHaConosciuto || "",
      },
    ],
  });

  return (
    <div className="bg-black">
      <Helmet>
        <title>Contatta Careisgold | Assistenza e Informazioni</title>
        <meta name="description" content="Hai domande su investimenti in oro? Contatta Careisgold per assistenza professionale e informazioni su prodotti e servizi. Siamo qui per te." />
        <meta name="keywords" content="contatti Careisgold, assistenza oro, informazioni investimenti, supporto clienti" />
        <meta property="og:title" content="Contatta Careisgold | Assistenza e Informazioni" />
        <meta property="og:description" content="Hai domande su investimenti in oro? Contatta Careisgold per assistenza professionale e informazioni su prodotti e servizi. Siamo qui per te." />
        <meta property="og:image" content={ogImage} />
        <meta property="og:url" content="https://www.careisgold.it/contatti/" />
        <meta property="og:type" content="page" />
        <link rel="canonical" href="https://www.careisgold.it/contatti/" />
        <script type="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Careisgold SpA",
          "url": "https://www.careisgold.it/contatti/",
          "logo": "https://www.careisgold.it${logo}",
          "description": "Hai domande su investimenti in oro? Contatta Careisgold per assistenza professionale e informazioni su prodotti e servizi. Siamo qui per te.",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Via Monte Baldo 14/D",
            "addressLocality": "Villafranca di Verona",
            "addressRegion": "Veneto",
            "postalCode": "37069",
            "addressCountry": "IT"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+39 045 8213155",
            "contactType": "Customer Service"
          },
          "sameAs": [
            "https://www.facebook.com/careisgoldspa",
            "https://www.instagram.com/careisgoldspa",
            "https://www.linkedin.com/company/careisgold-spa"
          ]
        }
      `}
        </script>
      </Helmet>
      
      <Static
      headerImage={headerImage}
      title='Scopri un mondo di opportunità: contattaci subito'
      description=''
      logoTransp=''/>
      
      <div className='flex items-center justify-center pt-20 '>
        <div className='w-full px-4 lg:px-0'>
          <div className="flex flex-col lg:flex-row items-start justify-evenly">
            <div className='w-full lg:w-3/6'>
              <Form
                landingName={'sito careisgold.it'}
                submitMapper={submitMapper}
                getFields={getContactFormFields}
                formSchema={schemaContattiCare}
              />
            </div>
            <div className='w-full lg:w-2/6 py-8 lg:py-16'>
              <div className='w-full bg-slate-50'>
                {showMap && (
                  <Wrapper apiKey={googleMaps}>
                    <GoogleMaps />
                  </Wrapper>
                )}
              </div>
              <div className='w-full text-start text-slate-50 py-10'>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item bg-light ms-0 ps-0 flex items-center mb-3">
                    <FaMapMarkerAlt className="me-5" />
                    <a className="text-decoration-none text-dark font-medium opacity-75" rel="noreferrer noopener" href="https://goo.gl/maps/y7ADbUdXX1ZZppbK9" target="_blank">
                      <p className="m-0">Via Monte Baldo, 14/D 37069 Villafranca di Verona (VR)</p>
                    </a>
                  </li>
                  <li className="list-group-item bg-light ms-0 ps-0 flex items-center mb-3">
                    <FaPhone className="me-5" />
                    <a className="text-decoration-none text-dark font-medium opacity-75" href="tel:045 2457421" rel="noreferrer noopener">
                      <p className="m-0">045 2457421</p>
                    </a>
                  </li>
                  <li className="list-group-item bg-light ms-0 ps-0 flex items-center mb-3">
                    <FaEnvelope className="me-5" />
                    <a className="text-decoration-none text-dark font-medium opacity-75" href="mailto:info@careisgold.it" rel="noreferrer noopener">
                      <p className="m-0 lowercase">INFO@CAREISGOLD.IT</p>
                    </a>
                  </li>
                </ul>
                <h3 className="text-lg font-semibold mt-4">
                  Sede legale:
                </h3>
                <p className="mt-2 pb-4">
                  Via Monte Baldo 14/D, Villafranca di Verona <br />
                  C.F./P.Iva 04598560235 - REA VR-433912<br />
                  CAP. 37069 SOCIALE € 2.000.000,00 i.v.<br />
                  <a className="text-decoration-none text-dark" href="mailto:careisgoldspa@pec.careisgold.it" rel="noreferrer noopener">careisgoldspa@pec.careisgold.it</a><br />
                  Operatore Professionale Oro - iscritto nel registro OAM n. OPO6
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contatti;
